import api from './index';

const getAllMetaDataByType = (data: any) => api.get(`/metadata/${data}`);
const getDemogByStudentId = (studentId: string) =>
  api.get(`/metadata/student-demog/${studentId}`);

export { getAllMetaDataByType, getDemogByStudentId };
